import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ResolveAlertRequest as SchemaResolveAlertRequest } from '../schemas/ResolveAlertRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Alerts
 */
export const ResolveAlertContentType = 'application/json' as const;
export type ResolveAlertRequest = SchemaResolveAlertRequest;
export type ResolveAlertResponses = LinkCommonErrorResponses & {
    /**
     * @description Alert resolved successfully
     */
    '200': {};
};
export type ResolveAlertResponseSuccess = undefined;
export type ResolveAlertSearchParams = undefined;
export type ResolveAlertPathParameters = undefined;
export const ResolveAlertUrl = '/alerts/resolve' as const;
export const ResolveAlertMethod = 'POST' as const;
export const getResolveAlertUrl = (_params?: ResolveAlertPathParameters) => ResolveAlertUrl;
